"use client";

import { type Context, createContext } from "react";

/**
 * Hook to create a named context in one line
 * @param name name of the context
 */
export function createNamedContext<T>(name: string): Context<T | undefined>;
/**
 * Hook to create a named context in one line with a default value
 * @param name name of the context
 * @param defaultValue the initial context value
 */
export function createNamedContext<T>(name: string, defaultValue: T): Context<T>;
export function createNamedContext<T>(name: string, defaultValue?: T): Context<T | undefined> {
  const NamedContext = createContext<T | undefined>(defaultValue);
  NamedContext.displayName = name;

  return NamedContext;
}
